import { boolean, number, object, string } from "yup";

import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  dueDays: 0,
  status: StatusEnum.ACTIVE,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  description: string().required("Harus diisi"),
  dueDays: number()
    .required("Harus diisi")
    .transform((value) => (isNaN(value) ? 0 : value))
    .min(0, "Minimal 0"),
  status: boolean().required("Harus diisi"),
});
